import React from 'react';
import backgroundImage from '../../assets/landing2.jpg';
import AboutSection from "./aboutSection";
import useSEO from "../../hooks/useSEO";

const Home = () => {
    useSEO({
        title: "Fyzioterapie Frýdek-Místek — UrbanFyzio | Mgr. Šimon Urban",
        description: "Soukromá fyzioterapeutická ambulance ve Frýdku-Místku. Individuální péče, moderní techniky DNS a osobní přístup pro sportovce i běžnou populaci.",
        path: "/",
    });

    return (
        <div className="flex flex-col w-full min-h-screen bg-surface">

            {/* Hero */}
            <section
                className="relative bg-cover bg-center bg-no-repeat min-h-[70vh] w-full flex items-center justify-center"
                style={{ backgroundImage: `url(${backgroundImage})` }}
            >
                <div className="absolute inset-0 bg-hero-fade" />
                <div className="relative z-10 text-center px-6 max-w-3xl animate-fade-up">
                    <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/15 backdrop-blur-sm border border-white/20 text-white/95 text-xs md:text-sm font-medium tracking-wide mb-6">
                        <span className="w-1.5 h-1.5 rounded-full bg-brand-300" />
                        Soukromá fyzioterapeutická ambulance
                    </span>
                    <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-[1.05] tracking-tight text-shadow">
                        Fyzioterapie
                        <span className="block text-brand-200">Frýdek-Místek</span>
                    </h1>
                    <p className="mt-6 text-base md:text-xl text-white/90 max-w-2xl mx-auto leading-relaxed text-shadow">
                        Najdeme příčinu bolesti, postavíme plán a vrátíme vás zpět do pohybu.
                    </p>
                    <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
                        <a
                            href="https://urbanfyzio.reservio.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn-primary text-base px-6 py-3"
                        >
                            Rezervovat termín
                            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <line x1="5" y1="12" x2="19" y2="12" />
                                <polyline points="12 5 19 12 12 19" />
                            </svg>
                        </a>
                        <a
                            href="tel:+420734312843"
                            className="btn-ghost text-base px-6 py-3 border border-white/30"
                        >
                            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.37 1.9.72 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.35 1.85.59 2.81.72A2 2 0 0 1 22 16.92z" />
                            </svg>
                            +420 734 312 843
                        </a>
                    </div>

                    {/* Trust line */}
                    <div className="mt-10 flex flex-wrap gap-x-6 gap-y-2 justify-center text-white/80 text-sm">
                        <span className="inline-flex items-center gap-2">
                            <CheckIcon /> Individuální přístup
                        </span>
                        <span className="inline-flex items-center gap-2">
                            <CheckIcon /> Moderně vybavené prostředí
                        </span>
                        <span className="inline-flex items-center gap-2">
                            <CheckIcon /> Sportovci i běžná populace
                        </span>
                    </div>
                </div>
            </section>

            {/* About Section */}
            <div className="container-narrow section w-full">
                <AboutSection />
            </div>

        </div>
    );
};

const CheckIcon = () => (
    <svg className="w-4 h-4 text-brand-300" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <polyline points="20 6 9 17 4 12" />
    </svg>
);

export default Home;
